import COLORS from './config.json'

type CssVarTypography =
  | 'config-header-color' // Heading color
  | 'config--main-color-night' // Text color
  | 'config-meta-text-color' // Metadata color

type CssVarPalette =
  | 'config--main-color-brand' // aka Primary
  | 'config--main-color-brand-secondary' // aka Secondary
  | 'config--main-color-disabled'
  | 'config--main-color-success'
  | 'config--main-color-alert'
  | 'config--main-color-info'

type CssVarHelperColors =
  | 'config--main-border-base-color' // Border color
  | 'config-body-background-color' // Page background color
  | 'config-main-navigation-search-placeholder-color' // Placeholder color

/**
 * @deprecated do not use these colors
 */
type MixedCssVar =
  | 'config-notification-widget-background-color'
  | 'config-notification-widget-color'
  | 'config-widget-cta-background-color'
  | 'config-widget-cta-color'
  | 'config-hero-color'
  | 'config-subcategory-hero-color'
  | 'config-topic-question-color'

export type CssVar = CssVarTypography | CssVarPalette | CssVarHelperColors | MixedCssVar

/**
 * This function is used to render a valid CSS var syntax:
 * ```
 * style={{ color: getCssVar('config-header-color') }}
 * ```
 */
export const getCssVar = (name: CssVar): string => {
  return `var(--${name})`
}

export const getCssVarLabel = (name: CssVar): string => {
  const foundColor = COLORS.find((color) => color.key === name)
  if (foundColor) {
    return foundColor.title
  }
  return `Unknown color (${name})`
}
